<template>
  <div id="app">
    <router-view :key="$route.fullPath"></router-view>
    <PwaInstallPrompt />
  </div>
</template>

<script>
import PwaInstallPrompt from '@/components/PwaInstallPrompt.vue';

export default {
  name: 'App',
  components: { PwaInstallPrompt }
};
</script>

<style>
/* Force Bootstrap modals and backdrops to sit above the navigation bar (z-index 1100) */
.modal-backdrop {
  z-index: 20050 !important;
}
.modal {
  z-index: 20060 !important;
}
</style>
